module.exports = __webpack_public_path__ + "static/media/1.2670fe97.jpg";